import React, { useState, useContext, useEffect } from 'react'
import { Link } from 'react-router-dom'
import Layout from '../../layouts/public'
import Input from '../../components/CustomInput'
import Button from '../../components/CustomButton'
import UserService from '../../services/Login'
import MessageLogin from '../../components/MessageLogin'
import {
    FormContainer,
    LinkContainer,
    SectionWrapper,
    ButtonContainer,
    Separator,
    ContainerTitle
} from './style'
import GeneralContext from '../../context/GeneralContext'
import { InvalidForm, Required, SupportMail } from '../../assets'
import validator from 'validator'
import DOMPurify from 'dompurify'
import { decryptText } from '../../helpers/encriptation'

const Login = () => {
    const { displayToast } = useContext(GeneralContext)
    const [isScreenLocked, setIsScreenLocked] = useState(false)
    const [username, setUsername] = useState({ value: '', error: '' })
    const [pass, setPass] = useState({ value: '', error: '' })

    useEffect(() => {
        const storageKey = 'sessionExpired'
        if (window.localStorage.getItem(storageKey)) {
            window.localStorage.removeItem(storageKey)
            displayToast({
                type: 'fail',
                message: 'El tiempo de sesión se ha acabado. Ingrese nuevamente'
            })
        }
    }, [])

    const findLoginErrors = () => {
        let error = false
        if (!username.value) {
            error = true
            setUsername({ value: '', error: Required })
        }
        if (!pass.value) {
            error = true
            setPass({ value: '', error: Required })
        }
        if (error) {
            displayToast({
                type: 'fail',
                message: InvalidForm
            })
        }
        return error
    }
    const handleLogin = async (event) => {
        event.preventDefault()
        setIsScreenLocked(true)
        try {
            if (!findLoginErrors()) {
                const result = await UserService.Login(username.value, pass.value)
                if (result.status === 205) {
                    setIsScreenLocked(false)
                    displayToast({
                        type: 'custom-fail',
                        title: 'Contraseña expirada',
                        message: 'Su contraseña expiro y debe ser cambiada.'
                    })
                } else if (result && result.status === 200) {
                    const jsonEncrypted = decryptText(result.data.data)
                    const jsonDataResponse = JSON.parse(jsonEncrypted)
                    window.localStorage.setItem('token_otp', jsonDataResponse.token)
                    window.localStorage.setItem('emailTo', jsonDataResponse.emailTo)
                    setIsScreenLocked(false)
                    window.location.href = '/otp'
                    return
                }
            } else {
                setIsScreenLocked(false)
            }
        } catch (e) {
            setIsScreenLocked(false)
            if (
                e?.response?.status === 400 &&
                e?.response?.data?.message === 'UserTemporarilyLocked'
            ) {
                displayToast({
                    type: 'custom-fail',
                    title: 'Demasiados intentos fallidos',
                    message: `Su cuenta ha sido bloqueada por superar el número de intentos. Inténtalo nuevamente en ${e?.response?.data?.errors?.unlockIn} minutos.`
                })
            } else {
                displayToast({
                    type: 'fail',
                    message: 'Usuario o contraseña incorrecto'
                })
            }
        }
    }

    const handleEmail = (str) => {
        if (validator.isEmail(str)) {
            const mailto = `mailto:${str}`
            const clean = DOMPurify.sanitize(mailto, {
                ALLOWED_URI_REGEXP:
                    /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp|xxx):|[^a-z]|[a-z+.-]+(?:[^a-z+.\-:]|$))/i
            })

            return (
                <a href={clean} type="secondary" download target="_blank" rel="noopener noreferrer">
                    Soporte
                </a>
            )
        }
    }

    return (
        <Layout blocking={isScreenLocked} showLogin>
            <SectionWrapper>
                <FormContainer autoComplete="off" onSubmit={handleLogin}>
                    <ContainerTitle>
                        <MessageLogin />
                    </ContainerTitle>
                    <Input
                        data={username}
                        onChange={(e) => {
                            setUsername({ value: e.target.value, error: '' })
                        }}
                        type="text"
                        placeholder="Usuario"
                        label="Usuario *"
                        autoComplete="off"
                        name="username"
                    />
                    <div>
                        <Input
                            data={pass}
                            onChange={(e) => {
                                setPass({ value: e.target.value, error: '' })
                            }}
                            name="password"
                            type="password"
                            placeholder="********"
                            label="Contraseña *"
                            autoComplete="off"
                            showPassword
                        />
                    </div>
                    <div className="d-flex flex-column-reverse flex-lg-column">
                        <ButtonContainer>
                            <Button
                                locked={isScreenLocked}
                                type="submit"
                                onClick={handleLogin}
                                buttonType="primary"
                                size="lg"
                                category="default"
                            >
                                Ingresar
                            </Button>
                        </ButtonContainer>
                        <div className="link-container">
                            <Link type="primary" to="/password/forgot">
                                Olvidé mi contraseña
                            </Link>
                        </div>
                    </div>
                </FormContainer>
            </SectionWrapper>
            <LinkContainer className="row">
                <div className="col-12 col-lg-12 text-center p-0">{handleEmail(SupportMail)}</div>
                <Separator className="d-lg-block col-12 text-center" />
                <div className="col-12 col-lg-12 text-center p-0">
                    <Link to="/faqs" type="secondary">
                        Preguntas frecuentes
                    </Link>
                </div>
                <Separator className="d-lg-block col-12 text-center" />
                <div className="col-12 col-lg-12 text-center p-0">
                    <Link to="/privacy-policy" type="secondary">
                        Políticas de privacidad
                    </Link>
                </div>
            </LinkContainer>
        </Layout>
    )
}
export default Login
